import reduxCrud from 'redux-crud';

const passengersActionCreators = reduxCrud.actionCreatorsFor('passengers', {
  key: 'id',
});
const actionTypes = reduxCrud.actionTypesFor('passengers', { key: 'id' });

export default passengersActionCreators;
export { actionTypes };
